// src/firebase.js

// Import Firebase SDKs
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Firebase Configuration
const firebaseConfig = {
  apiKey: "AIzaSyCKLMR6vz51PHLFsDMcWgrwaeTHlGa2Vqc",
  authDomain: "asianclimatecontrols-aced7.firebaseapp.com",
  databaseURL: "https://asianclimatecontrols-aced7-default-rtdb.firebaseio.com",
  projectId: "asianclimatecontrols-aced7",
  storageBucket: "asianclimatecontrols-aced7.firebasestorage.app",
  messagingSenderId: "56785539524",
  appId: "1:56785539524:web:3eddb3412fd5ced3139491",
  measurementId: "G-C2PNTS5P91",
};

// ✅ 1. Initialize Firebase FIRST
const app = initializeApp(firebaseConfig);

// ✅ 2. Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// ✅ 3. Set persistence AFTER auth exists
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("✅ Auth persistence set to LOCAL");
  })
  .catch((err) => {
    console.error("❌ Auth persistence error:", err);
  });

// ✅ 4. Analytics (optional – works only on https/localhost)
let analytics;
try {
  analytics = getAnalytics(app);
} catch (e) {
  console.warn("Analytics not supported in this environment");
}

export { analytics };
